module.exports = __webpack_public_path__ + "img/gestion_humana.7a644bac.jpeg";